import { IconProps } from "../../utils/global-types/global-types";

const VerbaFloLogoWithAlertIcon = ({ className }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
  >
    <path
      fill="url(#paint0_radial_5302_93210)"
      d="M13.94 8.998c0 1.217 1.86 2.36 1.31 3.348-1.31 2.353-3.348 3.476-5.864 3.476-2.283 0-3.004-1.713-4.22-3.476-.764-1.107-2.508-1.894-2.508-3.348 0-2.337 1.702-2.923 3.468-4.153 1.082-.753 1.849-2.67 3.26-2.67 3.716 0 4.555 3.055 4.555 6.823"
    ></path>
    <path
      fill="url(#paint1_radial_5302_93210)"
      d="M13.94 8.998c0 1.217 1.86 2.36 1.31 3.348-1.31 2.353-3.348 3.476-5.864 3.476-2.283 0-3.004-1.713-4.22-3.476-.764-1.107-2.508-1.894-2.508-3.348 0-2.337 1.702-2.923 3.468-4.153 1.082-.753 1.849-2.67 3.26-2.67 3.716 0 4.555 3.055 4.555 6.823"
    ></path>
    <path
      fill="url(#paint2_radial_5302_93210)"
      d="M13.94 8.998c0 1.217 1.86 2.36 1.31 3.348-1.31 2.353-3.348 3.476-5.864 3.476-2.283 0-3.004-1.713-4.22-3.476-.764-1.107-2.508-1.894-2.508-3.348 0-2.337 1.702-2.923 3.468-4.153 1.082-.753 1.849-2.67 3.26-2.67 3.716 0 4.555 3.055 4.555 6.823"
    ></path>
    <g opacity="0.4" style={{ mixBlendMode: "plus-lighter" }}>
      <path
        fill="url(#paint3_radial_5302_93210)"
        d="M4.604 11.27c-.543-1.085-2.711-1.248-2.663-2.383.115-2.699 1.43-4.637 3.674-5.794 2.034-1.05 3.443.145 5.315 1.157 1.175.636 3.082.536 3.732 1.832 1.044 2.083-.21 3.388-1.236 5.297-.627 1.168-.454 3.23-1.712 3.878-3.312 1.709-5.425-.628-7.11-3.988"
      ></path>
      <path
        fill="url(#paint4_radial_5302_93210)"
        d="M4.604 11.27c-.543-1.085-2.711-1.248-2.663-2.383.115-2.699 1.43-4.637 3.674-5.794 2.034-1.05 3.443.145 5.315 1.157 1.175.636 3.082.536 3.732 1.832 1.044 2.083-.21 3.388-1.236 5.297-.627 1.168-.454 3.23-1.712 3.878-3.312 1.709-5.425-.628-7.11-3.988"
      ></path>
      <path
        fill="url(#paint5_radial_5302_93210)"
        d="M4.604 11.27c-.543-1.085-2.711-1.248-2.663-2.383.115-2.699 1.43-4.637 3.674-5.794 2.034-1.05 3.443.145 5.315 1.157 1.175.636 3.082.536 3.732 1.832 1.044 2.083-.21 3.388-1.236 5.297-.627 1.168-.454 3.23-1.712 3.878-3.312 1.709-5.425-.628-7.11-3.988"
      ></path>
    </g>
    <path
      stroke="url(#paint6_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.968 5.952c.46.809.668 1.553.674 2.242.005.688-.191 1.325-.545 1.922-.71 1.196-2.05 2.228-3.657 3.169-.273.16-.477.42-.647.717-.17.296-.31.633-.449.945-.14.315-.282.603-.454.814-.171.209-.369.337-.626.34-2.642.026-4.602-1.192-5.85-3.384-.562-.987-.571-1.844-.33-2.698.12-.429.305-.857.516-1.302.21-.441.45-.905.674-1.392.143-.312.237-.667.317-1.031.081-.368.147-.741.235-1.104.175-.723.43-1.365 1.03-1.715.981-.575 1.801-.566 2.617-.3.41.135.818.334 1.247.56.428.225.877.478 1.362.712.302.147.657.238 1.025.311q.277.055.562.102.284.05.561.106c.74.155 1.398.39 1.737.986Z"
    ></path>
    <path
      stroke="url(#paint7_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.968 5.952c.46.809.668 1.553.674 2.242.005.688-.191 1.325-.545 1.922-.71 1.196-2.05 2.228-3.657 3.169-.273.16-.477.42-.647.717-.17.296-.31.633-.449.945-.14.315-.282.603-.454.814-.171.209-.369.337-.626.34-2.642.026-4.602-1.192-5.85-3.384-.562-.987-.571-1.844-.33-2.698.12-.429.305-.857.516-1.302.21-.441.45-.905.674-1.392.143-.312.237-.667.317-1.031.081-.368.147-.741.235-1.104.175-.723.43-1.365 1.03-1.715.981-.575 1.801-.566 2.617-.3.41.135.818.334 1.247.56.428.225.877.478 1.362.712.302.147.657.238 1.025.311q.277.055.562.102.284.05.561.106c.74.155 1.398.39 1.737.986Z"
    ></path>
    <path
      stroke="url(#paint8_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.968 5.952c.46.809.668 1.553.674 2.242.005.688-.191 1.325-.545 1.922-.71 1.196-2.05 2.228-3.657 3.169-.273.16-.477.42-.647.717-.17.296-.31.633-.449.945-.14.315-.282.603-.454.814-.171.209-.369.337-.626.34-2.642.026-4.602-1.192-5.85-3.384-.562-.987-.571-1.844-.33-2.698.12-.429.305-.857.516-1.302.21-.441.45-.905.674-1.392.143-.312.237-.667.317-1.031.081-.368.147-.741.235-1.104.175-.723.43-1.365 1.03-1.715.981-.575 1.801-.566 2.617-.3.41.135.818.334 1.247.56.428.225.877.478 1.362.712.302.147.657.238 1.025.311q.277.055.562.102.284.05.561.106c.74.155 1.398.39 1.737.986Z"
    ></path>
    <path
      stroke="url(#paint9_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.888 11.976c.453-.796.657-1.528.663-2.205.006-.678-.188-1.306-.536-1.893-.698-1.176-2.017-2.191-3.598-3.117-.268-.157-.47-.415-.637-.706-.167-.29-.304-.623-.442-.93-.138-.309-.277-.593-.446-.8-.168-.206-.363-.331-.616-.334-2.599-.026-4.527 1.172-5.755 3.33-.552.97-.562 1.813-.325 2.653.12.421.3.842.509 1.28.206.434.442.89.662 1.37.142.307.234.656.313 1.016.08.362.144.728.23 1.085.173.712.425 1.343 1.013 1.687.966.566 1.772.557 2.574.294.403-.131.806-.328 1.228-.55s.864-.47 1.34-.7c.298-.144.647-.234 1.009-.307q.273-.053.553-.1.278-.048.552-.104c.728-.152 1.375-.383 1.709-.97Z"
    ></path>
    <path
      stroke="url(#paint10_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.888 11.976c.453-.796.657-1.528.663-2.205.006-.678-.188-1.306-.536-1.893-.698-1.176-2.017-2.191-3.598-3.117-.268-.157-.47-.415-.637-.706-.167-.29-.304-.623-.442-.93-.138-.309-.277-.593-.446-.8-.168-.206-.363-.331-.616-.334-2.599-.026-4.527 1.172-5.755 3.33-.552.97-.562 1.813-.325 2.653.12.421.3.842.509 1.28.206.434.442.89.662 1.37.142.307.234.656.313 1.016.08.362.144.728.23 1.085.173.712.425 1.343 1.013 1.687.966.566 1.772.557 2.574.294.403-.131.806-.328 1.228-.55s.864-.47 1.34-.7c.298-.144.647-.234 1.009-.307q.273-.053.553-.1.278-.048.552-.104c.728-.152 1.375-.383 1.709-.97Z"
    ></path>
    <path
      stroke="url(#paint11_radial_5302_93210)"
      strokeWidth="0.116"
      d="M14.888 11.976c.453-.796.657-1.528.663-2.205.006-.678-.188-1.306-.536-1.893-.698-1.176-2.017-2.191-3.598-3.117-.268-.157-.47-.415-.637-.706-.167-.29-.304-.623-.442-.93-.138-.309-.277-.593-.446-.8-.168-.206-.363-.331-.616-.334-2.599-.026-4.527 1.172-5.755 3.33-.552.97-.562 1.813-.325 2.653.12.421.3.842.509 1.28.206.434.442.89.662 1.37.142.307.234.656.313 1.016.08.362.144.728.23 1.085.173.712.425 1.343 1.013 1.687.966.566 1.772.557 2.574.294.403-.131.806-.328 1.228-.55s.864-.47 1.34-.7c.298-.144.647-.234 1.009-.307q.273-.053.553-.1.278-.048.552-.104c.728-.152 1.375-.383 1.709-.97Z"
    ></path>
    <g clipPath="url(#clip0_5302_93210)">
      <g clipPath="url(#clip1_5302_93210)">
        <path
          fill="#FACC15"
          d="M17.26 7.221 14.12 1.45a1.302 1.302 0 0 0-2.24 0L8.74 7.221a1.301 1.301 0 0 0 1.12 1.967h6.28a1.302 1.302 0 0 0 1.12-1.967M13 8.147a.522.522 0 1 1 .001-1.043A.522.522 0 0 1 13 8.147m.52-2.084a.522.522 0 0 1-1.04 0V3.46a.522.522 0 0 1 1.04 0z"
        ></path>
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-.00512 13.6469 -12.6936 -.0049 9.01 2.175)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#78DFFF"></stop>
        <stop offset="0.603" stopColor="#78DFFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint1_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(12.7038 0 0 12.154 2.658 9.04)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6BBFF" stopOpacity="0.711"></stop>
        <stop stopColor="#C6BBFF"></stop>
        <stop offset="1" stopColor="#C6BBFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint2_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(4.05351 19.2836 -17.9365 3.87808 8.007 1.073)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.404" stopColor="#285BD5" stopOpacity="0"></stop>
        <stop offset="0.895" stopColor="#285BD5"></stop>
      </radialGradient>
      <radialGradient
        id="paint3_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-6.09538 -12.1664 11.3165 -5.83158 12.05 15.084)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#78DFFF"></stop>
        <stop offset="0.603" stopColor="#78DFFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint4_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-11.3235 5.84064 -5.43264 -10.8334 14.643 6.044)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6BBFF" stopOpacity="0.711"></stop>
        <stop stopColor="#C6BBFF"></stop>
        <stop offset="1" stopColor="#C6BBFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint5_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-12.2326 -15.3247 14.2542 -11.7031 13.436 15.605)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.404" stopColor="#285BD5" stopOpacity="0"></stop>
        <stop offset="0.895" stopColor="#285BD5"></stop>
      </radialGradient>
      <radialGradient
        id="paint6_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-11.6558 6.81894 -6.3426 -11.1513 14.83 5.592)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#78DFFF"></stop>
        <stop offset="0.603" stopColor="#78DFFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint7_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(6.35189 11.1579 -10.3784 6.07698 5.79 3.446)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6BBFF" stopOpacity="0.711"></stop>
        <stop stopColor="#C6BBFF"></stop>
        <stop offset="1" stopColor="#C6BBFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint8_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-14.4398 13.202 -12.2798 -13.8148 15.269 4.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.404" stopColor="#285BD5" stopOpacity="0"></stop>
        <stop offset="0.895" stopColor="#285BD5"></stop>
      </radialGradient>
      <radialGradient
        id="paint9_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-11.4691 -6.70972 -6.24101 10.9727 14.753 12.33)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#78DFFF"></stop>
        <stop offset="0.603" stopColor="#78DFFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint10_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(6.25015 -10.9791 -10.2122 -5.97965 5.859 14.441)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6BBFF" stopOpacity="0.711"></stop>
        <stop stopColor="#C6BBFF"></stop>
        <stop offset="1" stopColor="#C6BBFF" stopOpacity="0"></stop>
      </radialGradient>
      <radialGradient
        id="paint11_radial_5302_93210"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-14.2085 -12.9906 -12.0831 13.5935 15.185 13.739)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.404" stopColor="#285BD5" stopOpacity="0"></stop>
        <stop offset="0.895" stopColor="#285BD5"></stop>
      </radialGradient>
      <clipPath id="clip0_5302_93210">
        <path fill="#fff" d="M8 0h10v10H8z"></path>
      </clipPath>
      <clipPath id="clip1_5302_93210">
        <path fill="#fff" d="M8.556.556h8.889v8.889h-8.89z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default VerbaFloLogoWithAlertIcon;
